import { CloseCircleOutlined, StopOutlined, SwapOutlined } from '@ant-design/icons';
import { THEME } from '@common/constants/theme.constant';
import React from 'react';
import 'twin.macro';

export const Tips = ({ className }: { className?: string }): JSX.Element => (
    <div
        tw="flex flex-col p-4 gap-2 text-sm font-light rounded-md"
        className={className}
        css={`
            background-color: ${THEME.GRAY_200};
        `}
    >
        <div tw="items-center">
            <SwapOutlined />
            <span tw="ml-2">Skip & swap your box easily</span>
        </div>
        <div tw="items-center">
            <StopOutlined />
            <span tw="ml-2">Pick exclusions and add-ons</span>
        </div>
        <div tw="items-center">
            <CloseCircleOutlined />
            <span tw="ml-2">Cancel at any time</span>
        </div>
    </div>
);
